<template>
<div id='file-upload-progress'>
  <div class='progress-elements'>
    <span class='loading_percent'>
      <span class='progress-text'>{{uploadProgress.message}}</span>
    </span>
    <svg :width="(circle_loader.radius*2)+(circle_loader.stroke_width*2)" :height="(circle_loader.radius*2)+(circle_loader.stroke_width*2)">
    <circle
      id='loading-track'
      :stroke-width="circle_loader.stroke_width"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="0"
      :cx="circle_loader.radius+circle_loader.stroke_width"
      :cy="circle_loader.radius+circle_loader.stroke_width"
      :r="circle_loader.radius"
      transform=""
      class="outer"></circle>
    <circle
      :stroke-width="circle_loader.stroke_width"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="circularLoadedPercent"
      :cx="circle_loader.radius+circle_loader.stroke_width"
      :cy="circle_loader.radius+circle_loader.stroke_width"
      :r="circle_loader.radius"
      transform=""
      class="outer"></circle>
    </svg>
  </div>
</div>
</template>
<script>
export default {
  props: ['uploadProgress'],
  data () {
    return {
      circle_loader: {
        radius: 80,
        dash_offset: 0,
        stroke_width: 3
      }
    }
  },
  computed: {
    isSuccess () {
      return this.uploadProgress === 100
    },
    circumference () {
      return 2 * Math.PI * this.circle_loader.radius
    },
    circularLoadedPercent () {
      var val = this.uploadProgress.progress
      var c = Math.PI * (this.circle_loader.radius * 2)

      if (val < 0) { val = 0 }
      if (val > 100) { val = 100 }

      var pct = ((100 - val) / 100) * c

      return pct
    }
  }
}
</script>
<style lang='scss'>
.progress-elements{
  position: relative;
  .loading_percent{
    position: absolute;
    top:50%;
    display: block;
    transform:translateY(-50%);
    width: 100%;
    text-align: center;
    i{
      @include font-size(1.75);
      color: blue;
    }
    .progress-text{
      color: blue;
      font-size: 1.2rem;
      @include type_medium;
    }
  }
  svg{
    circle{
      stroke: blue;
      fill: transparent;
      transition: stroke-dashoffset 1s linear;
      position: relative;
      z-index: 2;
      &#loading-track{
        position: relative;
        z-index:1;
        stroke:#dbdbdb;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/product-designer/FileUploadProgress.vue